<template>
    <Dropdown class="modules" @on-click="handleClick">
      <span>{{module.name}}</span>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem v-for="(item, key) in $config.modules" :name="key" :key="key" :class="{active: item.id === module.id}">{{item.name}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters(['module'])
  },
  methods: {
    handleClick (key) {
      if (this.module.id !== this.$config.modules[key].id) {
        this.$store.dispatch('setModule', this.$config.modules[key]).then(() => {
          this.$router.push({path: this.$config.modules[key].url})
        })
      }
    }
  }
}
</script>

<style lang="less">
.modules {
    margin-left: 30px;
    vertical-align: middle;
    font-size: 14px;
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    .ivu-dropdown-rel {
        height: 100%;
    }
    .ivu-dropdown-item {
        &.active {
            color: #409bff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/main/components/header-bar/modules/modules.vue